import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_VDOLIVESET,
  GET_VDOLIVESET_BY_LIVECLASSSCHEDULEID,
  GET_VDOLIVESETS,
  GET_VDOLIVESETS_BY_FILTER,
  ADD_VDOLIVESET,
  UPDATE_VDOLIVESET,
  DELETE_VDOLIVESET
} from '@/queries/modules/live-class/vdo-live-set.js';

export async function getVdoLiveSets(context) {

  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOLIVESETS,
        fetchPolicy: 'network-only'
      });
    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setVdoLiveSets', data.getVdoLiveSets);
      context.commit('setSuccess', null);
      return data.getVdoLiveSets
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getVdoLiveSetsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOLIVESETS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setVdoLiveSets', data.getVdoLiveSetsByFilter);
      context.commit('setSuccess', null);

      return data.getVdoLiveSetsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getVdoLiveSet(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOLIVESET,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;


    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setVdoLiveSet', data.getVdoLiveSet);
      context.commit('setSuccess', null);
      return data.getVdoLiveSet
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getVdoLiveSetByLiveClassScheduleId(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_VDOLIVESET_BY_LIVECLASSSCHEDULEID,
        variables: payload,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;


    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setVdoLiveSet', data.getVdoLiveSetByLiveClassScheduleId);
      context.commit('setSuccess', null);
      return data.getVdoLiveSetByLiveClassScheduleId
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addVdoLiveSet(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_VDOLIVESET,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const vdoLiveSets = [...context.state.vdoLiveSets];
      vdoLiveSets.push(data.addVdoLiveSet);
      context.commit('setVdoLiveSets', vdoLiveSets);
      context.commit('setSuccess', newItemSuccess(data.addVdoLiveSet.topicLocal));

      return data.addVdoLiveSet;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateVdoLiveSet(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_VDOLIVESET,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.vdoLiveSets.findIndex(item => item.id === data.updateVdoLiveSet.id);
      const vdoLiveSets = [
        ...context.state.vdoLiveSets.slice(0, index),
        data.updateVdoLiveSet,
        ...context.state.vdoLiveSets.slice(index + 1)
      ];
      context.commit('setVdoLiveSets', vdoLiveSets);
      context.commit('setSuccess', updateItemSuccess(data.updateVdoLiveSet.topicLocal));

      return data.updateVdoLiveSet
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteVdoLiveSet(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_VDOLIVESET,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.vdoLiveSets.findIndex(item => item.id === data.deleteVdoLiveSet.id);
      const vdoLiveSets = [
        ...context.state.vdoLiveSets.slice(0, index),
        ...context.state.vdoLiveSets.slice(index + 1)
      ];
      context.commit('setVdoLiveSets', vdoLiveSets);
      context.commit('setSuccess', deleteItemSuccess(data.deleteVdoLiveSet.topicLocal));

      return data.deleteVdoLiveSet
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

